export default __webpack_public_path__ + "static/media/heroImage.5fdee855.svg";